export default __webpack_public_path__ + "7f9c0409aa6d5e921f724f7e7106845a.jpg";